module.exports = __webpack_public_path__ + "img/maxmara_baidu.41a05089.gif";